<template>
  <div class="summary-box mt-3" v-if="summary">
    <h6 class="mb-2">Resumen de validacion</h6>
    <CRow>
      <CCol md="3" sm="6" class="mb-2" v-for="item in cards" :key="item.label">
        <div class="summary-item">
          <div class="summary-label">{{ item.label }}</div>
          <div class="summary-value">{{ item.value }}</div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: 'ImportValidationSummary',
  props: {
    summary: {
      type: Object,
      default: null
    }
  },
  computed: {
    cards() {
      if (!this.summary) {
        return []
      }

      return [
        { label: 'Total filas', value: this.summary.total_rows || 0 },
        { label: 'Filas validas', value: this.summary.valid_rows || 0 },
        { label: 'Advertencias', value: this.summary.warning_rows || 0 },
        { label: 'Errores', value: this.summary.error_rows || 0 },
        { label: 'Invitados nuevos', value: this.summary.new_guests || 0 },
        { label: 'Invitados a actualizar', value: this.summary.updated_guests || 0 },
        { label: 'Posibles duplicados', value: this.summary.duplicates || 0 },
        { label: 'Filas ignoradas', value: this.summary.ignored_rows || 0 }
      ]
    }
  }
}
</script>

<style scoped>
.summary-box {
  border: 1px solid #d8dbe0;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
}

.summary-item {
  border: 1px solid #eceff3;
  border-radius: 6px;
  padding: 8px;
  min-height: 68px;
}

.summary-label {
  font-size: 12px;
  color: #617080;
}

.summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
}
</style>
